export default __webpack_public_path__ + "static/media/55t.12b7fe23.jpg";